.fileCard {
	display: flex;
	width: 100%;
	justify-content: space-between;
	align-items: center;
	background-color: #f9f9f9;
	padding: 0.625rem 0.9375rem;
	border-radius: 10px;
}

.fileInfoSection {
	display: flex;
	gap: 0.9375rem;
	align-items: center;
	width: 100%;
}

.fileDetailsCol {
	display: flex;
	flex-direction: column;
	gap: 0.3125rem;

	.fileName {
		color: #333333;
		font-size: 0.9375rem;
		font-weight: 500;
		line-height: 1.5;
		word-break: break-all;
	}
}

.fileInfoRow {
	display: flex;
	gap: 0.625rem;
	align-items: center;

	& :global(.MuiTypography-root) {
		color: #6e6e6e;
		font-size: 0.875rem;
		line-height: 1.6;
		font-weight: 400;
	}
}

.fileActionSection {
	display: flex;
	align-items: center;
	gap: 0.625rem;

	.fileActionButton {
		width: 30px;
		height: 30px;
		border-radius: 7.5px;
	}
}

.statusContainer {
	display: flex;
	align-items: center;
	gap: 0.3125rem;

	& svg {
		flex-shrink: 0;
		width: 16px;
		height: 16px;
	}
}

.checkMarkWrapper {
	display: flex;
	flex-shrink: 0;
	align-items: center;
	justify-content: center;
	width: 16px;
	height: 16px;
	border-radius: 50%;
	background-color: #48a600;
	border: 0.9px solid #48a600;

	& svg {
		color: #fff;
		width: 8px;
		height: 8px;
	}
}

@media (max-width: 768px) {
	.fileCard {
		flex-direction: column;
		justify-content: unset;
		gap: 0.5rem;
	}

	.fileActionSection {
		width: 100%;

		& .downloadButton {
			width: 100%;
		}
	}
}
